// extracted by mini-css-extract-plugin
export var actions = "_rm-4";
export var item = "_rm-1";
export var price = "_rm-3";
export var quantity = "_rm-2";
export var table = "_rm-0";